import React, {Component} from 'react';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Actions, { thunks } from '../../redux/modules/auth';
import { ErrorText, Loader, Alert } from '../../components';

class Login extends Component {
    state = {
        form: {
            username: '',
            password: '',
        },
        errors : {}
    }

    onInputChange = e => {
        const { target: { name, value } } = e
        this.setState(state => ({
            form: {
                ...state.form,
                [name]: value,
            },
            errors: {
                ...state.errors,
                [name]: '',
            }
        }))
    }

    onSubmit = e => {
        e.preventDefault();
        if (!this.validateForm()) return
        this.props.dispatch(thunks.userLogin({
            ...this.state.form,
        }, this.props.history))
    }

    validateForm = () => {
        const { form } = this.state
        const errors = {}

        if (form.username === "") errors.username = 'Username is required';
        if (form.password === "") errors.password = 'Password is required';

        this.setState({ errors });

        return isEmpty(errors)
    }

    render() {
        const { loading, error, updateProperty } = this.props;
        const { form, errors } = this.state
        return (
            <div className="app flex-row align-items-center">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="card-group mb-0">
                                <div className="card p-4">
                                    <div className="card-body">
                                        <h1>Login</h1>
                                        <p className="text-muted">Sign In to your account</p>
                                        <div className="form-group mb-3">
                                            <input 
                                                name="username"
                                                type="text" 
                                                placeholder="Username" 
                                                className={classNames('form-control', { 'is-invalid': errors.username })} 
                                                value={form.username}
                                                onChange={this.onInputChange}
                                            />
                                            <ErrorText error={errors.username}/>
                                        </div>
                                        <div className="form-group mb-4">
                                            <input 
                                                name="password" 
                                                type="password" 
                                                placeholder="Password" 
                                                className={classNames('form-control', { 'is-invalid': errors.password })} 
                                                value={form.password}
                                                onChange={this.onInputChange}
                                            />
                                            <ErrorText error={errors.password}/>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-6">
                                                <button  className="btn btn-primary px-4 ml-3" onClick={this.onSubmit}>Login</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Loader show={loading}/>
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Login"
                    message={error}
                />
            </div>
        );
    }
}

const mapStateToProps = ({
    auth: {
        loading,
        error,
    },
}) => ({
    loading,
    error,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
